import { betDetailApi } from '../api/BetDetailApi'
import { IBetDetailApi } from '../api/IBetDetailApi'
import { IOpBetDetailApi } from '../api/IOpBetDetailApi'
import { opBetDetailApi } from '../api/OpBetDetailApi'
import { GameType, SpinType, useBetDetailStore } from '../store/betDetailStore'

export class BetDetailService {
  private betDetailApi: IBetDetailApi
  private opBetDetailApi: IOpBetDetailApi

  constructor(betDetailApi: IBetDetailApi, opBetDetailApi: IOpBetDetailApi) {
    this.betDetailApi = betDetailApi
    this.opBetDetailApi = opBetDetailApi
  }

  public async getBetDetail(refNo: number, statementDate: string) {
    const data = await this.betDetailApi.getBetDetail(refNo, statementDate)
    useBetDetailStore.setState({ betDetailData: data, currentMgIndex: 0, currentFgIndex: 0 })
  }

  public async getOpBetDetail() {
    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams.get('payload')) {
      const time = urlParams.get('time')
      const data = await this.opBetDetailApi.getOpBetDetail(urlParams.get('payload') as string, time as string)
      useBetDetailStore.setState({ isFromOpBetDetail: true, betDetailData: data, currentMgIndex: 0, currentFgIndex: 0 })
    }
  }

  public resetDetailData() {
    useBetDetailStore.setState({
      isOpen: false,
      betDetailData: null,
      selectShowGameType: GameType.MainGame,
      selectSpinType: SpinType.MainSpin,
    })
  }

  public goToNext() {
    const { getCurrentIndex, getHasNext, setCurrentIndex } = useBetDetailStore.getState()
    if (getHasNext()) {
      setCurrentIndex(getCurrentIndex() + 1)
    }
  }

  public goToPrevious() {
    const { getCurrentIndex, getHasPrev, setCurrentIndex } = useBetDetailStore.getState()
    if (getHasPrev()) {
      setCurrentIndex(getCurrentIndex() - 1)
    }
  }
}

export const betDetailService = new BetDetailService(betDetailApi, opBetDetailApi)
